export default {"src":"/_next/static/media/yellow_warning_icon.59e209e5.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};